import React from 'react';

import type {Spell, SpellDuration, SpellRange, SpellTime} from '../../../generated/types';
import {Markdown} from '../../../components/utils/md';
import {
	toSpellComponent,
	toSpellDuration,
	toSpellLinks,
	toSpellRange,
	toSpellTime,
} from '../../../components/render-helpers';

import markdownCss from '../../../components/utils/md/markdown.module.css';

type Props = {
	spell: Pick<Spell, 'time' | 'ritual' | 'range' | 'duration' | 'description'> & Partial<Spell>;
};

export const SpellDetails: React.FC<Props> = ({spell}) => (
	<>
		<div className={markdownCss.margin}>
			<div className={markdownCss.indent}>
				<Markdown text={`*Время сотворения:* ${toSpellTime(spell.time as SpellTime[], spell.ritual)}`} />
				<p>
					<b>Дистанция:</b> {toSpellRange(spell.range as SpellRange)}
				</p>
				<Markdown text={`*Компоненты:* ${toSpellComponent(spell as Spell)}`} />
				<p>
					<b>Длительность:</b> {toSpellDuration(spell.duration as SpellDuration[])}
				</p>
			</div>
		</div>
		<Markdown text={spell.description || ''} />
		<div className={markdownCss.indent}>{toSpellLinks(spell as Spell)}</div>
	</>
);
